@let unitsState = unitsState$ | async;
@let noticeCounts = noticeDataCount$ | async;
@let timeZone = timeZone$ | async;

@if (unitIdSet.size) {
  <div class="select-all">
    <label for="selectAllCheckbox">
      {{ selectedUnitIds.size }} / {{ units?.length || 0 }}
      {{ 'action.select-all' | translate }}
    </label>
    <mat-checkbox id="selectAllCheckbox" [labelPosition]="'after'"
      [checked]="isSelectAll$| async"
      [indeterminate]="selectedUnitIds.size > 0 && selectedUnitIds.size <  units.length"
      (change)="helperSelection($event)">
    </mat-checkbox>
  </div>
} @else {
  <p class="no-unit-message"> Нет объектов для отображения </p>
}


@if (unitsState) {
  <cdk-virtual-scroll-viewport class="unit-list-viewport"
    [itemSize]="ROW_HEIGHT"
    [style.height.px]="isSplitByUsers ? groupViewportHeight : null">
    <div *cdkVirtualFor="let unit of units; trackBy: trackById"
      class="list-option"
      [class.selected]="selectedUnitIds.has(unit.id)"
      (mouseenter)="hoveredUnit = unit"
      (mouseleave)="hoveredUnit = null"
      (click)="onRowClick(unit)">
      <app-unit-list-option class="row-content"
        [timeZone]="timeZone"
        [unit]="unit"
        [unitState]="unitsState.get(unit.id)"
        [unreadNotificationCount]="noticeCounts?.get(unit.id)?.getUnitCountNumb()"
        [highlight]="hoveredUnit?.id === unit.id || selectedUnitIds.has(unit.id)"
        [unitGroupView]="unitGroupViews.get(unit.id)">
      </app-unit-list-option>
      <mat-checkbox class="row-checkbox"
        [checked]="selectedUnitIds.has(unit.id)"
        (click)="$event.stopPropagation()"
        (change)="onCheckboxToggle(unit, $event)">
      </mat-checkbox>
    </div>
  </cdk-virtual-scroll-viewport>
}
